import { Component, Input, OnInit } from '@angular/core';
import { doCalculateItemPrice, IItem } from '../../../../shared/interfaces/iitem';
import { Router } from "@angular/router";
import { SessionService } from "../../../../shared/services/session.service";
import { ConfirmationModal } from "../../../../shared/components/dialog/dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { CommentDialogComponent } from "./comment-dialog/comment-dialog.component";
import { ItemSelector } from "../../../../states/Item/item.selectors";
import { Store } from "@ngrx/store";
import { DisLikeItem, ItemPostCommentReset, LikeItem } from "../../../../states/Item/item.actions";
import { ItemService } from "../../../services/item.service";

@Component({
	selector: 'app-item-tile',
	templateUrl: './item-tile.component.html',
	styleUrls: ['./item-tile.component.scss'],
})
export class ItemTileComponent implements OnInit {
	@Input() item: IItem;
	@Input() IsWishList: boolean
	public finalDiscountedPrice: number;
	public finalActualPrice: number;
	public isLike: boolean = false

	constructor(
		private router: Router,
		private sessionService: SessionService,
		private dialog: MatDialog,
		private store: Store,
		private itemService: ItemService,
	) {
	}

	getPrice(item: IItem) {
		if (this.finalActualPrice === this.finalDiscountedPrice) {
			return [this.finalActualPrice];
		} else {
			return [this.finalActualPrice, this.finalDiscountedPrice];
		}
	}

	get image(): string {
		if (!this.item?.images?.length) {
			return '';
		}
		const showOnListingImage = this.item?.images.find(img => img.showOnListing === true);
		return (showOnListingImage && showOnListingImage.ITEM_LISTING) ? showOnListingImage.ITEM_LISTING.s3url : this.item?.images[0].ITEM_LISTING.s3url;
		// return (this.item?.images?.length) ? this.item?.images[0]?.ITEM_LISTING?.s3url : '';
	}

	ngOnInit(): void {
		[this.finalActualPrice, this.finalDiscountedPrice] = doCalculateItemPrice(this.item?.itemVariations);

		const like = this.item?.likes.find(like => like.accessId?.id === this.sessionService.state?.profile?.id)
		if (like) {
			this.isLike = true
		}
	}

	// public redirect($event: MouseEvent, item: IItem) {
	// 	$event.stopPropagation();
	// 	this.router.navigate(['/item', item.id]);
	// }

	public redirect($event: MouseEvent, item: IItem) {
		$event.stopPropagation();
		this.router.navigate(['/item', item?.uniqueName])
		// .then(() => {
		// 	window.location.reload();
		// });
	}

	public doLike($event: MouseEvent, item: IItem) {
		;
		$event.stopPropagation();
		if (this.sessionService?.state && this.sessionService?.state?.token) {
			if (item.likes && item.likes.length) {
				const like = item?.likes.find(like => like.accessId?.id === this.sessionService.state?.profile?.id)
				if (like) {
					this.store.dispatch(
						new DisLikeItem({
							itemId: item?.id,
							likeId: like?.id
						})
					);
					this.isLike = false
				} else {
					this.store.dispatch(
						new LikeItem({
							itemId: item?.id
						})
					);
					this.isLike = true
				}
			} else {
				this.store.dispatch(new LikeItem({
					itemId: item?.id
				}));
				this.isLike = true
			}
		} else {
			this.askForLogin();
		}
	}

	public doComment($event: MouseEvent, item: IItem) {
		$event.stopPropagation();
		if (this.sessionService?.state && this.sessionService?.state?.token) {
			const commentDialog = this.dialog.open(CommentDialogComponent, {
				width: '350px',
				hasBackdrop: true,
				data: {
					itemId: item?.id,
				}
			});

			this.subscribeToPostCommentResponse();
		} else {
			this.askForLogin();
		}
	}

	private askForLogin() {
		const dialog = this.dialog.open(ConfirmationModal, {
			width: 'auto',
			data: {
				dialogTitle: 'Login',
				dialogMessage: 'To perform this action you need to login',
				dailogCancelBtnTitle: 'Cancel',
				dailogSuccessBtnTitle: 'Continue',
				params: true,
			}
		});

		dialog.componentInstance.onSuccessEvent.subscribe(res => {
			this.dialog.closeAll();
			this.router.navigate(['login']);
		});
	}

	private subscribeToPostCommentResponse() {
		this.store.select(ItemSelector.selectPostCommentResponse).subscribe(ItemPostCommentResponse => {
			if (ItemPostCommentResponse) {
				this.dialog.closeAll();
				this.store.dispatch(new ItemPostCommentReset());
			}
		});
	}

	public addRemoveCompareItem($event: any, item: IItem) {
		if ($event) {
			this.itemService.AddItemToCompare(item);
		} else {
			this.itemService.RemoveItemFromCompare(item);
		}
	}

	public isItemIncludedInCompareList(item: IItem): boolean {
		return this.itemService.hasItemInCompareList(item)
	}

	getShortenedBrandName(fullName: string): string {
		const words = fullName.split(' ');
		let shortenedName = '';

		if (words.length === 2) {
			shortenedName = `${words[0]} ${words[1]}`;
		} else if (words.length === 3) {
			shortenedName = `${words[0]} ${words[2]}`;
		} else {
			shortenedName = fullName;
		}

		return shortenedName;
	}
}
